import { useEffect } from 'react';

const VERIFICATION = import.meta.env.VITE_GOOGLE_SITE_VERIFICATION as
  | string
  | undefined;

export const SiteVerification = () => {
  useEffect(() => {
    if (!VERIFICATION) return;
    let el = document.querySelector(
      'meta[name="google-site-verification"]'
    ) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement('meta');
      el.name = 'google-site-verification';
      document.head.appendChild(el);
    }
    el.content = VERIFICATION;
  }, []);

  return null;
};
